/**
 * Force Home editorial / manifesto to match design:
 * left-aligned continuous text + centered CTA
 */
(function () {
  function flattenEl(el) {
    if (!el) return;
    var text = (el.innerText || el.textContent || "")
      .replace(/[^\S\n]+/g, " ")
      .replace(/[ \t]*\n[ \t]*/g, "\n")
      .trim();
    el.textContent = text;
    el.style.setProperty("text-align", "left", "important");
    el.style.setProperty("white-space", "pre-line", "important");
    el.style.setProperty("margin", "0", "important");
    el.style.setProperty("max-width", "42rem", "important");
    el.style.setProperty("width", "100%", "important");
    el.style.setProperty("display", "block", "important");
  }

  function fixSection(root) {
    if (!root) return;

    root.style.setProperty("text-align", "left", "important");
    root.style.setProperty("padding", "5rem 1.5rem 4.5rem", "important");

    var copy =
      root.querySelector(".t-editorial__copy, .t-manifesto__copy") ||
      root.querySelector(".t-editorial__intro");
    flattenEl(copy);

    // If copy is the intro wrapper, also flatten child nodes into one p
    if (copy && copy.classList.contains("t-editorial__intro")) {
      var text = (copy.innerText || "").replace(/\s+/g, " ").trim();
      var cta = copy.querySelector(".t-editorial__cta, .t-manifesto__cta");
      var p = document.createElement("p");
      p.className = "t-editorial__copy";
      p.textContent = text.replace(/\s*Conocer más\s*$/, "").trim();
      flattenEl(p);
      copy.innerHTML = "";
      copy.appendChild(p);
      if (cta) copy.appendChild(cta);
    }

    var cta = root.querySelector(".t-editorial__cta, .t-manifesto__cta");
    if (cta) {
      cta.style.setProperty("display", "block", "important");
      cta.style.setProperty("width", "fit-content", "important");
      cta.style.setProperty("margin", "3rem auto 0", "important");
      cta.style.setProperty("text-align", "center", "important");
      cta.style.setProperty("font-weight", "700", "important");
      cta.style.setProperty("border", "0", "important");
      cta.style.setProperty("background", "none", "important");
      cta.style.setProperty("padding", "0", "important");
      cta.style.setProperty("color", "#1a1a1a", "important");
      cta.style.setProperty("text-decoration", "none", "important");
    }
  }

  function run() {
    document.querySelectorAll(".t-editorial, .t-manifesto").forEach(fixSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Theme editor re-renders sections asynchronously
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:select", run);
  setTimeout(run, 300);
  setTimeout(run, 1000);
})();
